import React from 'react';
import { InputRow, Button, nameInput } from '../';
import classnames from 'classnames';

import { ImCheckmark, ImCross } from 'react-icons/im';

import styles from './buttonGroup.module.scss';

const ButtonGroup = ({
  text,
  color,
  inputClassName,
  type,
  leftImage,
  centerImage,
  rightImage,
  selected,
  name,
  onClick,
  disabled,
  shrink,
  testID,
  imageClass,
  ...props
}) => {
  return (
    <InputRow {...props} className={styles.buttonGroup}>
      <Button
        onClick={() => onClick(1)}
        inputClassName={styles.button}
        className={styles.inputGroup}
        icon={
          <ImCheckmark
            size={32}
            className={classnames([
              styles.check,
              {
                [styles.iconSelected]: selected === 1,
                [styles.iconNotSelected]: selected && selected !== 1
              }
            ])}
          />
        }
        testID="safeButton"
        disabled={disabled}
        color={selected === 1 ? 'green' : 'white'}
      />
      <Button
        onClick={() => onClick(2)}
        middle
        inputClassName={styles.button}
        className={styles.inputGroup}
        icon={
          <ImCross
            size={28}
            className={classnames([
              styles.cross,
              {
                [styles.iconSelected]: selected === 2,
                [styles.iconNotSelected]: selected && selected !== 2
              }
            ])}
          />
        }
        testID="unsafeButton"
        disabled={disabled}
        color={selected === 2 ? 'red' : 'white'}
      />
      <Button
        onClick={() => onClick(3)}
        image={rightImage}
        middle
        inputClassName={styles.button}
        className={styles.inputGroup}
        imageClass={classnames([
          styles.image,
          selected === 3 ? styles.white : selected ? styles.greyCheck : ''
        ])}
        color={selected === 3 ? 'grey' : 'white'}
        testID="NAButton"
        disabled={disabled}
      />
    </InputRow>
  );
};

const nButtonGroup = nameInput(ButtonGroup);
export { nButtonGroup as ButtonGroup };
export default nButtonGroup;
